import BaseClient from '@/app/model/api/response/baseApiClient'

class AiAdvicePlansApi extends BaseClient {
  public getAiAdvicePlans (id: string) {
    const path = '/v1/ai-advice/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new AiAdvicePlansApi()
